import { must, $, $$ } from '@/lib/dom';
import { ICON } from '@/lib/icons';
import { state, save } from '@/store/state';
import { setLayout, applyFit, setView } from './grid';
import { toggleScanPanel } from './panel';
import { toggleFullscreen } from './kiosk';
import { pool } from '@/engine/pool';
import { isMobile } from '@/config';
import type { Layout } from '@/engine/types';
import * as bus from '@/lib/bus';

export function initToolbar(): void {
  const bar = must('#toolbar');
  bar.innerHTML = `
    <button class="ico" id="panelBtn" title="แผงกล้อง" aria-label="แผงกล้อง">${ICON.panel}</button>
    <span class="mark"><b>gin9</b><i>·</i>กินไหน</span>
    <div class="seg" id="seg" role="group" aria-label="รูปแบบ">
      <span class="ind" id="segInd"></span>
      <button data-l="2x2">2×2</button><button data-l="3x3">3×3</button><button data-l="4x4">4×4</button><button data-l="fit">พอดีจอ</button>
    </div>
    <div class="grow"></div>
    <button class="vchip" id="viewChip" hidden title="ล้างตัวกรอง"></button>
    <div class="tele mono"><span id="teleStreams"><b>0</b> สด</span><span class="d">·</span><span id="teleFps"><b>0</b> fps</span></div>
    <button class="ico" id="scanBtn" title="สแกน" aria-label="สแกน">${ICON.scan}</button>
    <button class="ico" id="gutterBtn" title="ช่องไฟ" aria-label="ช่องไฟ">${ICON.gutter}</button>
    <button class="ico" id="fsBtn" title="เต็มจอ" aria-label="เต็มจอ">${ICON.fs}</button>
    <span class="clock mono" id="clock">--:--:--</span>`;

  $('#seg')!.addEventListener('click', (e) => {
    const b = (e.target as HTMLElement).closest<HTMLElement>('button');
    if (b?.dataset['l']) setLayout(b.dataset['l'] as Layout);
  });
  $('#panelBtn')!.addEventListener('click', togglePanel);
  $('#scanBtn')!.addEventListener('click', () => { toggleScanPanel(); syncControls(); });
  $('#gutterBtn')!.addEventListener('click', () => {
    state.gutter = state.gutter === 'comfy' ? 'dense' : 'comfy';
    document.documentElement.style.setProperty('--gap', state.gutter === 'comfy' ? '8px' : '6px');
    applyFit();
    save();
    syncControls();
  });
  $('#fsBtn')!.addEventListener('click', toggleFullscreen);
  $('#viewChip')!.addEventListener('click', () => setView({ source: 'all', onlineOnly: false }));

  bus.on('wall:changed', syncControls);
  bus.on('controls:sync', syncControls);
  bus.on('view:changed', syncControls);
  syncControls();
}

function togglePanel(): void {
  const app = must('#app');
  if (isMobile()) {
    app.classList.toggle('drawer-open');
  } else {
    state.panelOpen = !state.panelOpen;
    app.classList.toggle('panel-closed', !state.panelOpen);
    save();
    applyFit();
  }
  syncControls();
}

export function syncControls(): void {
  for (const b of $$('#seg button')) b.classList.toggle('on', b.dataset['l'] === state.layout);
  moveIndicator();
  $('#gutterBtn')?.setAttribute('aria-pressed', String(state.gutter === 'comfy'));
  const app = must('#app');
  $('#panelBtn')?.setAttribute('aria-pressed', String(isMobile() ? app.classList.contains('drawer-open') : state.panelOpen));
  $('#scanBtn')?.setAttribute('aria-pressed', String(document.getElementById('scanPanel')?.classList.contains('open') ?? false));
  // A filtered wall is easy to forget once the panel is closed: say so up here.
  const chip = $('#viewChip') as HTMLButtonElement | null;
  if (chip) {
    const parts = [
      state.view.source === 'canteen' ? 'โรงอาหาร' : state.view.source === 'cctv' ? 'จราจร' : '',
      state.view.onlineOnly ? 'ออนไลน์' : '',
    ].filter(Boolean);
    chip.hidden = !parts.length;
    chip.textContent = `กรอง: ${parts.join(' · ')} ✕`;
  }
  // a filter forces 'fit', so the layout buttons would lie about what is shown
  $('#seg')?.classList.toggle('is-forced', state.view.source !== 'all' || state.view.onlineOnly);
  const fs = !!document.fullscreenElement;
  const fsBtn = $('#fsBtn');
  if (fsBtn) { fsBtn.innerHTML = fs ? ICON.fsExit : ICON.fs; fsBtn.setAttribute('aria-pressed', String(fs)); }
}

function moveIndicator(): void {
  const act = $('#seg button.on') as HTMLElement | null;
  const ind = $('#segInd') as HTMLElement | null;
  if (!ind) return;
  if (!act) { ind.style.width = '0'; return; }
  ind.style.width = `${act.offsetWidth}px`;
  ind.style.transform = `translateX(${act.offsetLeft - 2}px)`;
}

export function updateTele(): void {
  let fps = 0;
  for (const t of pool.attached) fps += t.fps;
  const s = $('#teleStreams');
  if (s) s.innerHTML = `<b>${pool.attached.size}</b> สด`;
  const f = $('#teleFps');
  if (f) f.innerHTML = `<b>${fps}</b> fps`;
}
